import BaseInteraction from '../player/BaseInteraction';
import logger from '../log';
import { NonStdPlayerEvents } from '../common/Reporter/constants';
import { dispatchPlayerEvent } from '../events/dispatch';
import MsftPlugin from '../microsoft/MsftPlugin';

const log = logger.getLogger(__filename);

const {
  playbackstarted: { code: e }
} = NonStdPlayerEvents;

interface PlaybackStartedState {
  currentTime?: number;
  hasTriggered?: boolean;
  tag?: ReturnType<typeof setInterval>;
}

export function handleClearInterval(state: PlaybackStartedState): void {
  if (!state.tag) {
    return;
  }
  clearInterval(state.tag);
}

/**
 * Setup a listener that will send a synthetic player event when the current
 * time starts changing for microsoft plugins.
 * @param plugin - the MsftPlugin
 * @param interval - the time between checks
 */
export function setupPlaybackStartedForMicrosoft(
  plugin: MsftPlugin,
  interval = 200
): PlaybackStartedState {
  const state: PlaybackStartedState = {};
  state.tag = setInterval(() => {
    const element: HTMLMediaElement = plugin.getVideoElement();
    setupPlaybackStartedEvent(element, state);
  }, interval);
  log.info('Called setInterval for Microsoft synthetic 106 event');
  return state;
}

/**
 * Setup a listener that will send a synthetic player event when the current
 * time starts changing.
 * @param playerInteraction - the object to get the element from
 * @param interval - the time between checks
 */
function setupPlaybackStarted(
  playerInteraction: BaseInteraction<unknown>,
  interval = 200
): PlaybackStartedState {
  const state: PlaybackStartedState = {};
  state.tag = setInterval(() => {
    if (state.hasTriggered) {
      handleClearInterval(state);
      return;
    }

    const element = playerInteraction.mediaElement();
    setupPlaybackStartedEvent(element, state);
  }, interval);
  log.info('Called setInterval for Ksdk synthetic 106 event');
  return state;
}

function setupPlaybackStartedEvent(
  element: HTMLMediaElement | undefined,
  state: PlaybackStartedState
): PlaybackStartedState {
  if (!element) {
    log.trace('No element found, unable to track currentTime');
    return state;
  }
  if (typeof state.currentTime === 'undefined') {
    state.currentTime = element.currentTime;
  } else if (state.currentTime !== element.currentTime) {
    dispatchPlayerEvent({ e });
    state.hasTriggered = true;
    handleClearInterval(state);
  }
  return state;
}

export default setupPlaybackStarted;
